import { Search, X } from "lucide-react";
import { useMemo, useState } from "react";
import { currentFocus, skillGroups } from "../data/skills";
import { SectionHeading } from "./SectionHeading";

export function SkillsSection() {
  const [query, setQuery] = useState("");
  const filteredGroups = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return skillGroups;
    return skillGroups
      .map((group) => ({ ...group, skills: group.skills.filter((skill) => skill.toLowerCase().includes(normalized)) }))
      .filter((group) => group.skills.length || group.title.toLowerCase().includes(normalized));
  }, [query]);

  return (
    <section id="skills" className="section skills-section">
      <div className="shell">
        <div className="section-heading-row skills-heading-row">
          <SectionHeading
            number="05"
            eyebrow="Skills / working toolkit"
            title="Broad range. Deliberate application."
            description="A searchable view of technologies I have used across research, projects, study and engineering work."
          />
          <label className="skill-search">
            <span className="sr-only">Search skills</span>
            <Search aria-hidden="true" />
            <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search the toolkit" />
            {query && <button type="button" onClick={() => setQuery("")} aria-label="Clear skill search"><X aria-hidden="true" /></button>}
          </label>
        </div>

        <div className="skill-grid" aria-live="polite">
          {filteredGroups.map((group, index) => (
            <article className="skill-card panel" key={group.title}>
              <div className="skill-card-header"><span>S/{String(index + 1).padStart(2, "0")}</span><p>{group.label}</p></div>
              <h3>{group.title}</h3>
              <ul>{group.skills.map((skill) => <li key={skill}>{skill}</li>)}</ul>
            </article>
          ))}
          {!filteredGroups.length && <p className="empty-state">No matching skill. Try a broader term.</p>}
        </div>

        <div className="focus-panel panel">
          <div>
            <p className="eyebrow">Currently exploring</p>
            <h3>Useful AI needs the whole system.</h3>
            <p>I am exploring how perception, language, data systems and modern web technologies can combine into reliable, accessible intelligent applications.</p>
          </div>
          <ul>{currentFocus.map((focus) => <li key={focus}>{focus}</li>)}</ul>
        </div>
      </div>
    </section>
  );
}
